import React from 'react';
import { HeartIcon, InstagramIcon, LockIcon, MailIcon, ShieldCheckIcon, SmartphoneIcon, ZapIcon } from 'lucide-react';
const badges = [{
  icon: SmartphoneIcon,
  label: 'Acceso digital'
}, {
  icon: ZapIcon,
  label: 'Acceso inmediato'
}, {
  icon: LockIcon,
  label: 'Pago seguro'
}, {
  icon: ShieldCheckIcon,
  label: 'Garantía de 7 días'
}];
export function Footer() {
  return <footer className="bg-teal-900 pb-10 pt-9 text-cream-50 sm:pb-14 sm:pt-14" data-id="element-102" data-mp="3ueiltxwqx4dz">
      <div className="mx-auto max-w-4xl px-5 text-center sm:px-8" data-id="element-103" data-mp="38qtcrvhxfo0">
        <p className="inline-flex items-center gap-2 font-display text-base font-900 uppercase tracking-wide sm:text-lg" data-id="element-104" data-mp="37xvkgeim0i0">
          <HeartIcon className="h-4 w-4 text-gold-400 sm:h-5 sm:w-5" aria-hidden="true" data-id="element-105" data-mp="3qdf4f6z1v0an" />
          Mega Pack Acompañante
        </p>
        <p className="mx-auto mt-2.5 max-w-xl text-[0.8rem] leading-relaxed text-cream-100/70 sm:mt-4 sm:text-sm" data-id="element-106" data-mp="29yxcxcohlklt">
          Una biblioteca completa de actividades para acompañar, compartir y dejar de
          improvisar.
        </p>
        <p className="mt-2 font-display text-[0.7rem] font-700 uppercase tracking-[0.14em] text-gold-400 sm:mt-3 sm:text-sm sm:tracking-[0.16em]" data-id="element-107" data-mp="3l9sj15twaup0">
          7 Tomos + 5 Bonos
        </p>

        <ul className="mt-5 flex flex-wrap items-center justify-center gap-x-4 gap-y-2 sm:mt-8 sm:gap-x-6 sm:gap-y-3" data-id="element-108" data-mp="3v8htwendjevr">
          {badges.map(({
          icon: Icon,
          label
        }) => <li key={label} className="flex items-center gap-1.5 text-xs text-cream-100/70 sm:gap-2 sm:text-sm" data-id="element-109" data-mp="828oa9xiabb9">
              <Icon className="h-3.5 w-3.5 text-gold-400 sm:h-4 sm:w-4" aria-hidden="true" data-id="element-110" data-mp="31umvaqetzm7" />
              {label}
            </li>)}
        </ul>

        <div className="mt-6 border-t border-cream-50/10 pt-4 sm:mt-10 sm:pt-6" data-id="element-111" data-mp="cus134odd2f0">
          <p className="text-[0.7rem] text-cream-100/50 sm:text-xs" data-id="element-112" data-mp="qt015lgpcjue">
            © 2026 — Todos los derechos reservados
          </p>
          <p className="mt-2 flex flex-wrap items-center justify-center gap-x-4 gap-y-1 text-[0.7rem] text-cream-100/60 sm:text-xs" data-id="element-113" data-mp="mthlp57nh0yy">
            <a href="https://instagram.com/armate_digital" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1.5 transition-colors duration-150 ease-out hover:text-gold-400" data-id="element-114" data-mp="tta24mu25a0e">
              <InstagramIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-115" data-mp="18lbvrp5jb6rz" />
              @armate_digital
            </a>
            <a href="mailto:armatedigitalsoporte@gmail.com" className="inline-flex items-center gap-1.5 transition-colors duration-150 ease-out hover:text-gold-400" data-id="element-116" data-mp="1cnyodsa14vq8">
              <MailIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-117" data-mp="1riv4ero2yndv" />
              armatedigitalsoporte@gmail.com
            </a>
          </p>
        </div>
      </div>
    </footer>;
}